import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#121214",
                        border: "1px solid rgba(255,255,255,0.12)",
                        borderRadius: 0,
                        color: "#f8fafc",
                        fontFamily: "Chivo, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
